/**
 * Real <a> links to the server-rendered pages.
 *
 * These pages are where the search traffic comes from. Crawlers need plain
 * anchors pointing at them from the app, otherwise the only way in is the
 * sitemap. Keep this component rendered on every screen.
 */

const CRAWLABLE_PAGES = [
  { href: "/funding", label: "Funding rounds" },
  { href: "/funding/archive", label: "Funding by month" },
  { href: "/layoffs", label: "Layoffs tracker" },
  { href: "/layoffs/archive", label: "Layoffs by month" },
  { href: "/investors", label: "Investor index" },
  { href: "/news", label: "Startup news" },
  { href: "/sitemap.xml", label: "Sitemap" },
];

export function SeoFooterLinks() {
  return (
    <footer className="sr-only">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
        Browse the public pages
      </p>
      <nav className="flex flex-wrap gap-x-4 gap-y-1.5">
        {CRAWLABLE_PAGES.map((page) => (
          <a
            key={page.href}
            href={page.href}
            className="text-[13px] text-gray-600 hover:text-brand hover:underline"
          >
            {page.label}
          </a>
        ))}
      </nav>
      <p className="mt-3 text-xs text-gray-500">
        © {new Date().getFullYear()} Cone Proposal Software.
      </p>
    </footer>
  );
}
